module.exports = __webpack_public_path__ + "media/images/story/top/point_2-76b33014520eea56e55c0623aaa3357f.svg";